export const kz = {
  badge: 'Белгі',
  open: 'Ашу',
  close: 'Жабу',
  dismiss: 'Жабу',
  confirmEdit: {
    ok: 'Жарайды',
    cancel: 'Бас тарту',
  },
  dataIterator: {
    noResultsText: 'Сәйкес жазбалар табылмады',
    loadingText: 'Жазба жүктелуде...',
  },
  dataTable: {
    itemsPerPageText: 'Беттегі жолдар саны:',
    ariaLabel: {
      sortDescending: 'Кему ретімен сұрыпталған.',
      sortAscending: 'Өсу ретімен сұрыпталған.',
      sortNone: 'Сұрыпталмаған.',
      activateNone: 'Сұрыптауды алып тастау үшін белсендіру.',
      activateDescending: 'Кему ретімен сұрыптау үшін белсендіру.',
      activateAscending: 'Өсу ретімен сұрыптау үшін белсендіру.',
    },
    sortBy: 'Сұрыптау',
  },
  dataFooter: {
    itemsPerPageText: 'Беттегі жазбалар:',
    itemsPerPageAll: 'Барлығы',
    nextPage: 'Келесі бет',
    prevPage: 'Алдыңғы бет',
    firstPage: 'Бірінші бет',
    lastPage: 'Соңғы бет',
    pageText: '{0}-{1} {2} ішінен',
  },
  dateRangeInput: {
    divider: 'дейін',
  },
  datePicker: {
    itemsSelected: '{0} таңдалды',
    range: {
      title: 'Таңдалған күндер',
      header: 'Күн енгізу',
    },
    title: 'Күн таңдау',
    header: 'Күн енгізу',
    input: {
      placeholder: 'Күн енгізіңіз',
    },
  },
  noDataText: 'Деректер жоқ',
  carousel: {
    prev: 'Алдыңғы слайд',
    next: 'Келесі слайд',
    ariaLabel: {
      delimiter: 'Слайд {0} {1} ішінен',
    },
  },
  calendar: {
    moreEvents: 'Тағы {0}',
    today: 'Бүгін',
  },
  input: {
    clear: 'Тазалау {0}',
    prependAction: '{0} алдын ала әрекет',
    appendAction: '{0} қосымша әрекет',
    otp: 'OTP символдарын енгізіңіз {0}',
  },
  fileInput: {
    counter: 'Файлдар: {0}',
    counterSize: 'Файлдар: {0} (барлығы {1})',
  },
  timePicker: {
    am: 'ТК',
    pm: 'ТК',
    title: 'Уақытты таңдау',
  },
  pagination: {
    ariaLabel: {
      root: 'Беттер арасында навигация',
      next: 'Келесі бет',
      previous: 'Алдыңғы бет',
      page: 'Бетке өту {0}',
      currentPage: 'Ағымдағы бет, Бет {0}',
      first: 'Бірінші бет',
      last: 'Соңғы бет',
    },
  },
  stepper: {
    next: 'Келесі',
    prev: 'Алдыңғы',
  },
  rating: {
    ariaLabel: {
      item: 'Бағалау {0} {1} ішінен',
    },
  },
  loading: 'Жүктелуде...',
  infiniteScroll: {
    loadMore: 'Тағы жүктеу',
    empty: 'Жүктейтін ештеңе жоқ',
  },
}
